"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var ISurvey = require("../Api/ISurvey");
var InterceptComponent = require("../SurveyComponents/InterceptComponent");
var Utils = require("../Utils");
var Survey_1 = require("./Survey");
var SurveyDataSource = require("./SurveyDataSource");
var isNOU = Utils.isNOU;
var InterceptSurvey = /** @class */function (_super) {
  __extends(InterceptSurvey, _super);
  function InterceptSurvey(data) {
    var _this = _super.call(this) || this;
    if (isNOU(data)) {
      throw new Error("data must not be null");
    }
    _this.surveyInfo = new SurveyDataSource(data.baseData);
    _this.intercept = new InterceptComponent(data.interceptData);
    return _this;
  }
  InterceptSurvey.make = function (data) {
    try {
      return new InterceptSurvey(data);
    } catch (e) {
      return null;
    }
  };
  InterceptSurvey.makeIntercept = function (baseData, sp, surveyModel) {
    if (isNOU(baseData) || isNOU(sp) || isNOU(surveyModel)) {
      return null;
    }
    var content = surveyModel.content;
    // Intercept component is required.
    if (isNOU(content) || isNOU(content.intercept)) {
      return null;
    }
    var data = new InterceptSurvey.InterceptSurveyData();
    data.baseData = baseData;
    data.interceptData = new InterceptComponent.InterceptComponentData();
    data.interceptData.title = sp.getCustomString(content.intercept.title);
    data.interceptData.question = sp.getCustomString(content.intercept.question);
    data.interceptData.url = sp.getCustomString(content.intercept.url);
    if (isNOU(data.interceptData.title) || isNOU(data.interceptData.question) || isNOU(data.interceptData.url)) {
      return null;
    }
    return this.make(data);
  };
  // @Override
  InterceptSurvey.prototype.getType = function () {
    return ISurvey.Type.Intercept;
  };
  // @Override
  InterceptSurvey.prototype.getSurveyInfo = function () {
    return this.surveyInfo;
  };
  // @Override
  InterceptSurvey.prototype.getInterceptComponent = function () {
    return this.intercept;
  };
  // @Override
  InterceptSurvey.prototype.getComponent = function (componentType) {
    return componentType === "Intercept" /* Intercept */ ? this.getInterceptComponent() : null;
  };
  // @Override
  InterceptSurvey.prototype.getDomElements = function (doc) {
    return [];
  };
  // @Override
  InterceptSurvey.prototype.getJsonElements = function () {
    return {};
  };
  return InterceptSurvey;
}(Survey_1.Survey);
(function (InterceptSurvey) {
  /**
   * Data required for an Intercept Survey
   */
  var InterceptSurveyData = /** @class */function () {
    function InterceptSurveyData() {}
    return InterceptSurveyData;
  }();
  InterceptSurvey.InterceptSurveyData = InterceptSurveyData;
})(InterceptSurvey || (InterceptSurvey = {}));
module.exports = InterceptSurvey;